import { createActionCreator, createAsyncActionCreator } from "@gamedev-web/gamedev-sdk-core";

import { PartnerId } from "../../../constants";

export const createOnboardingAsyncAction = createAsyncActionCreator(PartnerId);
export const createOnboardingAction = createActionCreator(PartnerId);
